<div>
  <div v-html="getColors"></div>
  <!-- <main-navbar v-if="!getEditorMode" /> -->
  <section class="bg-white dark:bg-gray-900 relative mainSection">
    <slot></slot>
  </section>
  <!-- <main-footer v-if="!getEditorMode"></main-footer> -->
</div>
